export default __webpack_public_path__ + "static/media/icon_check.11b53f10.svg";